module.exports = __webpack_public_path__ + "img/amazon_alexa.5783cc26.png";